module.exports = __webpack_public_path__ + "files/48c4c1b39579c8d20df959b3eb5ec009.svg";